export interface SmtpConfig {
  id?: string;
  centerGroupId?: number;
  host: string;
  port: number;
  username: string;
  password?: string;
  enableSsl: boolean;
  fromEmail: string;
  fromName: string;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface SmtpCreateRequest {
  host: string;
  port: number;
  username: string;
  password: string;
  enableSsl: boolean;
  fromEmail: string;
  fromName: string;
}

export interface SmtpUpdateRequest {
  host?: string;
  port?: number;
  username?: string;
  password?: string | null;
  enableSsl?: boolean;
  fromEmail?: string;
  fromName?: string;
  isActive?: boolean;
}

export interface SmtpTestRequest {
  testEmail: string;
}

export interface SmtpTestResponse {
  success: boolean;
  message: string;
  testedAt?: string;
}
